export function isContent(value) {
  return value === 'URL_STATIC' || value === 'URL_HTTP'
}
